import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ec5b28b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "b-step1-detail-wrapper" }
const _hoisted_2 = { class: "register1-detail" }
const _hoisted_3 = { class: "item text-overflow" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "账户名称：", -1))
const _hoisted_5 = {
  class: "item text-overflow",
  style: {"width":"350px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "开户行名称：", -1))
const _hoisted_7 = { class: "item text-overflow" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "账号：", -1))
const _hoisted_9 = { class: "item text-overflow" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "开户日期：", -1))
const _hoisted_11 = {
  class: "item text-overflow",
  style: {"width":"500px"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, " 基本存款账户编号（开户许可证可查）：", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "item text-overflow" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "客户经理姓名：", -1))
const _hoisted_16 = { class: "item text-overflow" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "客户经理电话/柜台电话：", -1))
const _hoisted_18 = { class: "list" }
const _hoisted_19 = { class: "list-label" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("开户回执资料")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "(全套)", -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]

import { ref, reactive, onMounted, withDefaults } from "vue";
import Image from "@/components/Image.vue";

export default /*#__PURE__*/_defineComponent({
  props: {
    detail: { default: () => {
      return {
        AccountName: "",
        BankName: "",
        AccountNumber: "",
        OpeningDate: "",
        DepositAccountNumber: "",
        AccountManagerName: "",
        AccountManagerPhone: "",
        PageFiles: () => [],
      };
    } }
  },
  setup(__props: any) {

const props = __props as { detail: {
      AccountName: string;
      BankName: string;
      AccountNumber: string;
      OpeningDate: string;
      DepositAccountNumber: string;
      AccountManagerName: string;
      AccountManagerPhone: string;
      PageFiles: any[];
    } }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(props.detail.AccountName), 1)
      ]),
      _createElementVNode("span", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", null, _toDisplayString(props.detail.BankName), 1)
      ]),
      _createElementVNode("span", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", null, _toDisplayString(props.detail.AccountNumber), 1)
      ]),
      _createElementVNode("span", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", null, _toDisplayString(props.detail.OpeningDate.split(" ")[0]), 1)
      ]),
      _createElementVNode("span", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("span", null, _toDisplayString(props.detail.DepositAccountNumber), 1)
      ]),
      _hoisted_13,
      _createElementVNode("span", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("span", null, _toDisplayString(props.detail.AccountManagerName), 1)
      ]),
      _createElementVNode("span", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("span", null, _toDisplayString(props.detail.AccountManagerPhone), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.detail.PageFiles, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "list-item",
          key: index
        }, [
          _createElementVNode("div", _hoisted_19, [
            (index == 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "开户许可证"))
              : _createCommentVNode("", true),
            (index == 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, "银行预留印鉴卡"))
              : _createCommentVNode("", true),
            (index == 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, _hoisted_25))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(), _createBlock(Image, {
            "disable-close": true,
            key: index,
            "file-type": item.AccessoryType,
            value: item.FileUrl,
            "download-link": {
            filename:
              index == 0
                ? '开户许可证'
                : index == 1
                ? '银行预留印鉴卡'
                : '开户回执资料(全套)',
            fileKey: index == 0 ? '631' : index == 1 ? '632' : '633',
          }
          }, null, 8, ["file-type", "value", "download-link"]))
        ]))
      }), 128))
    ])
  ]))
}
}

})